import React, { useState } from "react";
import { computeTickets, isEntryInPhase, pickDefaultPhaseIndex } from "libraries/stamp_rally";

// スタンプラリーで表示する種別の固定順と、1口あたりのスタンプ数。
// events/show.js の STAMP_TYPE_DEFS と同じ内容(表示先が別ディレクトリのため複製)。
const STAMP_TYPE_DEFS = [
  { type: "material_download",   label: "資料ダウンロード", perTicket: 3 },
  { type: "seminar_view",        label: "動画視聴",     perTicket: 3 },
  { type: "upsell_consultation", label: "無料相談予約", perTicket: 1 },
  { type: "monitor_apply",       label: "モニター応募", perTicket: 1 },
  { type: "referral_registration", label: "お友だち紹介", perTicket: 1 }
];

// サイト全体(イベントホーム+各コンテンツページ)常時表示のスタンプ状況ポップアップ。
// - 展開状態: 右上にカード形式で種別ごとの達成状況を表示
// - 縮小状態: 右上端の縦長タグ表示。タップで再展開
// - 縮小状態は保存しない(マウントの度に必ず展開状態から開始する)
export const StampRallyPopup = ({ stamp_entries, ticket_count, stamp_rally_description, stamp_rally_phases }) => {
  const [collapsed, setCollapsed] = useState(false);

  const allEntries = stamp_entries || [];
  const phases = stamp_rally_phases || [];

  // 期間が 0 件 → 全スタンプ。1 件以上 → StampRallySection と同じ基準で選んだ期で絞り込み。
  // (events/show.js の StampRallySection と同じロジック。判定・口数計算は libraries/stamp_rally を共有)
  const entries = phases.length === 0
    ? allEntries
    : allEntries.filter((e) => isEntryInPhase(e, phases[pickDefaultPhaseIndex(phases)]));

  const total = phases.length === 0
    ? (ticket_count || 0)
    : computeTickets(entries);

  const rows = STAMP_TYPE_DEFS.map((def) => {
    const count = entries.filter((e) => e.action_type === def.type).length;
    const completedTickets = Math.floor(count / def.perTicket);
    const remainder = count % def.perTicket;
    return { ...def, completedTickets, remainder };
  });

  if (collapsed) {
    return (
      <button
        type="button"
        onClick={() => setCollapsed(false)}
        aria-label="スタンプカードを開く"
        style={{
          position: "fixed", top: 96, right: 0, zIndex: 9999,
          writingMode: "vertical-rl", textOrientation: "mixed",
          background: "#CA4E0E", color: "#fff", border: "none",
          borderRadius: "8px 0 0 8px", padding: "12px 6px",
          fontSize: 12, fontWeight: 700, letterSpacing: "0.05em",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)", cursor: "pointer"
        }}
      >
        スタンプ {total}口
      </button>
    );
  }

  return (
    <div style={{
      position: "fixed", top: 96, right: 12, zIndex: 9999,
      width: 260, maxHeight: "70vh", overflowY: "auto",
      background: "#fff", borderRadius: 10,
      boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
      border: "1px solid #e7e5e4", padding: 12
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <span style={{ fontSize: 13, fontWeight: 800, color: "#44403c" }}>スタンプカード</span>
        <button
          type="button"
          onClick={() => setCollapsed(true)}
          aria-label="スタンプカードを縮小"
          style={{
            border: "none", background: "none", cursor: "pointer",
            fontSize: 18, color: "#a8a29e", lineHeight: 1, padding: 0
          }}
        >
          ›
        </button>
      </div>

      <div style={{ display: "flex", alignItems: "baseline", gap: 4, marginBottom: 10 }}>
        <span style={{ fontSize: 11, color: "#78716c" }}>合計</span>
        <span style={{ fontSize: 22, fontWeight: 800, color: "#488479" }}>{total}</span>
        <span style={{ fontSize: 11, color: "#78716c" }}>口</span>
      </div>

      {stamp_rally_description && (
        <p style={{
          fontSize: 10, color: "#78716c", lineHeight: 1.6,
          whiteSpace: "pre-wrap", margin: "0 0 10px"
        }}>
          {stamp_rally_description}
        </p>
      )}

      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, justifyContent: "center" }}>
        {rows.map((r) => {
          const achieved = r.completedTickets > 0;
          return (
            <div key={r.type} style={{
              display: "flex", flexDirection: "column", alignItems: "center",
              width: 66
            }}>
              <div style={{
                width: 40, height: 40, borderRadius: "50%", flexShrink: 0,
                border: achieved ? "2px solid #CA4E0E" : "2px dashed #d6d3d1",
                background: achieved ? "rgba(202,78,14,0.08)" : "#fafaf9",
                display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                {achieved && (
                  <span style={{
                    color: "#CA4E0E", fontWeight: 900, fontSize: 13,
                    letterSpacing: "-0.02em",
                    transform: "rotate(-8deg)"
                  }}>
                    済
                  </span>
                )}
              </div>
              <span style={{
                fontSize: 9, color: "#78716c", marginTop: 4,
                textAlign: "center", lineHeight: 1.3
              }}>
                {r.label}
              </span>
              {achieved && (
                <span style={{ fontSize: 9, fontWeight: 700, color: "#CA4E0E" }}>
                  {r.completedTickets}口
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
